import React, { Component, PropsWithChildren } from 'react';

interface IProps extends PropsWithChildren<{}> {}

export default class DialogHeader extends Component<IProps> {
    public render() {
        return <div className="dialog-header">{this.props.children}</div>;
    }
}
